import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSubmitExternalMatchStats } from "../api/MatchApiProvider";
import { useRetrieveUserExternalMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveExternalMatch } from "../api/MatchApiProvider";
import { useRetrieveTeam } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { ExternalMatchStatsForm } from "./ExternalMatchStatsForm";
export const UpdatePlayerExternalMatchStats = () => {
    const { id } = useNumericParams();
    const navigate = useNavigate();
    const { data: userExternalMatchPermissions, isLoading: userExternalMatchPermissionsIsLoading, error: userExternalMatchPermissionsError, } = useRetrieveUserExternalMatchPermissions({ externalMatchId: id });
    const { canModify = false, canModifyStats = false } = userExternalMatchPermissions || {};
    const canEditStats = canModify || canModifyStats;
    const { isLoading: useRetrieveExternalMatchIsLoading, error: useRetrieveExternalMatchError, data: externalMatch, } = useRetrieveExternalMatch({ id, enabled: canEditStats });
    const { data: team, isLoading: teamIsLoading, error: teamError, } = useRetrieveTeam({ id: externalMatch?.team });
    const { isLoading: submitStatsIsLoading, isError: submitStatsIsError, mutateAsync: submitStats, } = useSubmitExternalMatchStats(externalMatch);
    if (userExternalMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userExternalMatchPermissionsError) {
        return _jsx(ErrorView, { error: userExternalMatchPermissionsError });
    }
    if (!canEditStats) {
        return _jsx(NotFound, {});
    }
    if (submitStatsIsLoading ||
        useRetrieveExternalMatchIsLoading ||
        teamIsLoading ||
        !externalMatch) {
        return _jsx(Loading, {});
    }
    if (useRetrieveExternalMatchError || teamError) {
        return _jsx(ErrorView, { error: useRetrieveExternalMatchError || teamError });
    }
    if (!team || !externalMatch) {
        throw new Error("Team or external match data is not available.");
    }
    const onSubmit = async (externalMatchResult, playerExternalMatchStats) => {
        await submitStats({
            result: {
                teamScore: externalMatchResult.teamScore,
                opponentTeamScore: externalMatchResult.opponentTeamScore,
                matchReport: externalMatchResult.matchReport,
            },
            playerStats: Object.values(playerExternalMatchStats),
        });
        navigate(`/teams/${externalMatch.team}/external-matches/${id}/`);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: submitStatsIsError, message: "Failed to update match stats! Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["External Match Stats for ", team.name] }) }), _jsx(Typography, { variant: "subtitle2", children: format(new Date(externalMatch.kickOff), "MMMM do yyyy @ H:mma") }), _jsx(ExternalMatchStatsForm, { onSubmit: onSubmit, externalMatch: externalMatch, team: team })] }));
};
